import React from "react"
import * as style from "./RangeInput.module.scss"

const RangeInput = ({
  label,
  min,
  max,
  step,
  value,
  onChange,
  disabled = false
}) => {
  const handleChange = (event) => {
    const newValue = parseFloat(event.target.value)
    onChange(newValue)
  }

  return (
    <div className={style.rangeInput}>
      <label className={style.label}>
        {label}
        <span className={style.value}>{value}</span>
      </label>
      <input
        type="range"
        min={min}
        max={max}
        step={step}
        value={value}
        onChange={handleChange}
        disabled={disabled}
        className={style.slider}
      />
      <div className={style.range}>
        <span>{min}</span>
        <span>{max}</span>
      </div>
    </div>
  )
}

export default RangeInput 